export const IRIS_EMAIL = 'iris@fraud-front.com';
export const IRIS_PHONE_DISPLAY = '+1 (855) 471-1743';
const IRIS_PHONE_E164 = '+18554711743';
export const IRIS_SMS_HREF = `sms:${IRIS_PHONE_E164}`;
export const IRIS_CONTACT_PHONE_DISPLAY = '+1 (408) 579-9731';
export const IRIS_MAILTO_HREF = `mailto:${IRIS_EMAIL}`;
